import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CancelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cancel"}/>
}
